var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canGoBack)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',{domProps:{"innerHTML":_vm._s(`mdi-backburger`)}}),_vm._v(" "+_vm._s(_vm.$t('button.go_back'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }